module.exports = "/static/media/article07.0df4ead6.jpg";